module.exports = __webpack_public_path__ + "static/img/jjfa2.c6b659c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jjfa2.jpg
// module id = Kwdb
// module chunks = 1